module.exports = __webpack_public_path__ + "img/tarnovo.79ec680a.jpg";